(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cqz-eye-cream-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const marker = document.getElementById('cqz-eye-cream');
      if (!marker) return;
      const mobile = window.matchMedia('(max-width: 767px)');
      const description = document.querySelector('.cqz-ec-description');
      const outer = description?.closest('details');
      const heading = outer?.querySelector(':scope > summary');
      const outerWasOpen = outer?.open;
      const originalAttributes = heading ? Array.from(heading.attributes).map(attribute => [attribute.name, attribute.value]) : [];
      const toggle = description?.querySelector('.cqz-ec-toggle');
      const template = document.getElementById('cqz-eye-cream-payments');
      const purchase = document.querySelector('.cqz-ec-purchase');
      const price = document.querySelector('.hdt-product-info__list > .hdt-product__price');
      const buy = document.querySelector('.hdt-product-info__list > .hdt-product__buy-button');
      const backups = new Map();
      const replace = (node, content) => {
        if (!node) return;
        if (!backups.has(node)) backups.set(node, Array.from(node.childNodes));
        node.replaceChildren(content);
      };
      const cart = () => {
        if (!mobile.matches) return;
        const drawer = document.getElementById('CartDrawer');
        if (!drawer) return;
        const title = drawer.querySelector('.hdt-minicart-recommendations__title');
        if (title && title.textContent.trim() !== marker.dataset.recommendations) replace(title, marker.dataset.recommendations);
        const target = drawer.querySelector('.hdt-mini-cart__imgtrust-svgs');
        if (target && !target.dataset.cqzEcPayments) {
          target.dataset.cqzEcPayments = 'true';
          replace(target, template.content.cloneNode(true));
        }
      };
      const observer = new MutationObserver(cart);
      const sync = () => {
        observer.disconnect();
        if (mobile.matches) {
          if (purchase && buy) buy.after(purchase);
          if (outer) outer.open = true;
          if (heading) {
            heading.removeAttribute('aria-expanded');
            heading.setAttribute('role', 'heading');
            heading.setAttribute('aria-level', '2');
            heading.setAttribute('tabindex', '-1');
          }
          if (toggle) description.dataset.enhanced = 'true';
          const delivery = document.querySelector('.hdt-pr-popup__delivery');
          if (delivery && delivery.textContent.trim() !== marker.dataset.delivery) replace(delivery, marker.dataset.delivery);
          cart();
          const drawer = document.getElementById('CartDrawer');
          if (drawer) observer.observe(drawer, { childList: true, subtree: true });
        } else {
          if (purchase && price) price.after(purchase);
          if (outer) outer.open = outerWasOpen;
          if (heading) {
            for (const attribute of Array.from(heading.attributes)) heading.removeAttribute(attribute.name);
            for (const [name, value] of originalAttributes) heading.setAttribute(name, value);
          }
          if (description) delete description.dataset.enhanced;
          for (const [node, children] of backups) {
            if (node.isConnected) {
              node.replaceChildren(...children);
              delete node.dataset.cqzEcPayments;
            }
          }
          backups.clear();
        }
      };
      toggle?.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        toggle.querySelector('span').textContent = open ? '−' : '+';
      });
      heading?.addEventListener('click', event => {
        if (mobile.matches) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      mobile.addEventListener('change', sync);
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cqz-mobile-purchase-unified"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const purchase = document.getElementById('cqz-mobile-purchase');
      if (!purchase) return;
      const mobile = window.matchMedia('(max-width: 767px)');
      const anchor = document.createComment('cqz-mobile-purchase-position');
      purchase.before(anchor);
      let labelsObserver;

      const setText = (node, label) => {
        if (!node || !label || node.textContent.trim() === label) return;
        node.textContent = label;
      };
      const sync = () => {
        const buy = document.querySelector('.hdt-product-info__list > .hdt-product__buy-button');
        const inventory = document.querySelector('hdt-variant-inventory');
        const inventoryItem = inventory?.closest('.hdt-product__meta');
        if (mobile.matches) {
          if (buy) buy.after(purchase);
          if (inventoryItem) inventoryItem.hidden = true;
          setText(document.querySelector('.hdt-pr-popup__delivery'), purchase.dataset.delivery);
          setText(document.querySelector('.hdt-pr-popup__ask'), purchase.dataset.question);
          if (!labelsObserver) {
            const links = document.querySelector('.hdt-product__extra-link');
            labelsObserver = new MutationObserver(() => {
              setText(document.querySelector('.hdt-pr-popup__delivery'), purchase.dataset.delivery);
              setText(document.querySelector('.hdt-pr-popup__ask'), purchase.dataset.question);
            });
            if (links) labelsObserver.observe(links, { childList: true, subtree: true, characterData: true });
          }
        } else {
          anchor.after(purchase);
          if (inventoryItem) inventoryItem.hidden = false;
        }
      };

      mobile.addEventListener('change', sync);
      sync();
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cqz-neck-cream-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const marker = document.getElementById('cqz-neck-cream');
      if (!marker) return;
      const mobile = window.matchMedia('(max-width: 767px)');
      const description = document.querySelector('.cqz-nc-description');
      const outer = description?.closest('details');
      const heading = outer?.querySelector(':scope > summary');
      const outerWasOpen = outer?.open;
      const originalAttributes = heading ? Array.from(heading.attributes).map(attribute => [attribute.name, attribute.value]) : [];
      const toggle = description?.querySelector('.cqz-nc-toggle');
      const template = document.getElementById('cqz-neck-cream-payments');
      const purchase = document.querySelector('.cqz-nc-purchase');
      const price = document.querySelector('.hdt-product-info__list > .hdt-product__price');
      const buy = document.querySelector('.hdt-product-info__list > .hdt-product__buy-button');
      const backups = new Map();
      const replace = (node, content) => {
        if (!node) return;
        if (!backups.has(node)) backups.set(node, Array.from(node.childNodes));
        node.replaceChildren(content);
      };
      const cart = () => {
        if (!mobile.matches) return;
        const drawer = document.getElementById('CartDrawer');
        if (!drawer) return;
        const title = drawer.querySelector('.hdt-minicart-recommendations__title');
        if (title && title.textContent.trim() !== marker.dataset.recommendations) replace(title, marker.dataset.recommendations);
        const target = drawer.querySelector('.hdt-mini-cart__imgtrust-svgs');
        if (target && !target.dataset.cqzNcPayments) {
          target.dataset.cqzNcPayments = 'true';
          replace(target, template.content.cloneNode(true));
        }
      };
      const observer = new MutationObserver(cart);
      const sync = () => {
        observer.disconnect();
        if (mobile.matches) {
          if (purchase && buy) buy.after(purchase);
          if (outer) outer.open = true;
          if (heading) {
            heading.removeAttribute('aria-expanded');
            heading.setAttribute('role', 'heading');
            heading.setAttribute('aria-level', '2');
            heading.setAttribute('tabindex', '-1');
          }
          if (toggle) description.dataset.enhanced = 'true';
          const delivery = document.querySelector('.hdt-pr-popup__delivery');
          if (delivery && delivery.textContent.trim() !== marker.dataset.delivery) replace(delivery, marker.dataset.delivery);
          cart();
          const drawer = document.getElementById('CartDrawer');
          if (drawer) observer.observe(drawer, { childList: true, subtree: true });
        } else {
          if (purchase && price) price.after(purchase);
          if (outer) outer.open = outerWasOpen;
          if (heading) {
            for (const attribute of Array.from(heading.attributes)) heading.removeAttribute(attribute.name);
            for (const [name, value] of originalAttributes) heading.setAttribute(name, value);
          }
          if (description) delete description.dataset.enhanced;
          for (const [node, children] of backups) {
            if (node.isConnected) {
              node.replaceChildren(...children);
              delete node.dataset.cqzNcPayments;
            }
          }
          backups.clear();
        }
      };
      toggle?.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        toggle.querySelector('span').textContent = open ? '−' : '+';
      });
      heading?.addEventListener('click', event => {
        if (mobile.matches) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      mobile.addEventListener('change', sync);
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cqz-noir-aura-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const marker = document.getElementById('cqz-noir-aura');
      if (!marker) return;
      const mobile = window.matchMedia('(max-width: 767px)');
      const description = document.querySelector('.cqz-na-description');
      const outer = description?.closest('details');
      const heading = outer?.querySelector(':scope > summary');
      const outerWasOpen = outer?.open;
      const originalAttributes = heading ? Array.from(heading.attributes).map(a => [a.name,a.value]) : [];
      const toggle = description?.querySelector('.cqz-na-toggle');
      const template = document.getElementById('cqz-noir-aura-payments');
      const purchase = document.querySelector('.cqz-na-purchase');
      const price = document.querySelector('.hdt-product-info__list > .hdt-product__price');
      const buy = document.querySelector('.hdt-product-info__list > .hdt-product__buy-button');
      const backups = new Map();
      const replace = (node, content) => {
        if (!node) return;
        if (!backups.has(node)) backups.set(node, Array.from(node.childNodes));
        node.replaceChildren(content);
      };
      const cart = () => {
        if (!mobile.matches) return;
        const drawer = document.getElementById('CartDrawer');
        if (!drawer) return;
        const title = drawer.querySelector('.hdt-minicart-recommendations__title');
        if (title && title.textContent.trim() !== marker.dataset.recommendations) replace(title, marker.dataset.recommendations);
        const target = drawer.querySelector('.hdt-mini-cart__imgtrust-svgs');
        if (target && !target.dataset.cqzNaPayments) {
          target.dataset.cqzNaPayments = 'true';
          replace(target, template.content.cloneNode(true));
        }
      };
      const observer = new MutationObserver(cart);
      const sync = () => {
        observer.disconnect();
        if (mobile.matches) {
          if (purchase && buy) buy.after(purchase);
          if (outer) outer.open = true;
          if (heading) {
            heading.removeAttribute('aria-expanded');
            heading.setAttribute('role','heading');
            heading.setAttribute('aria-level','2');
            heading.setAttribute('tabindex','-1');
          }
          if (toggle) description.dataset.enhanced = 'true';
          const delivery = document.querySelector('.hdt-pr-popup__delivery');
          if (delivery && delivery.textContent.trim() !== marker.dataset.delivery) replace(delivery,marker.dataset.delivery);
          cart();
          const drawer = document.getElementById('CartDrawer');
          if (drawer) observer.observe(drawer,{childList:true,subtree:true});
        } else {
          if (purchase && price) price.after(purchase);
          if (outer) outer.open = outerWasOpen;
          if (heading) {
            for (const a of Array.from(heading.attributes)) heading.removeAttribute(a.name);
            for (const [name,value] of originalAttributes) heading.setAttribute(name,value);
          }
          if (description) delete description.dataset.enhanced;
          for (const [node,children] of backups) {
            if (node.isConnected) { node.replaceChildren(...children); delete node.dataset.cqzNaPayments; }
          }
          backups.clear();
        }
      };
      toggle?.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded',String(open));
        toggle.querySelector('span').textContent = open ? '−' : '+';
      });
      heading?.addEventListener('click', event => {
        if (mobile.matches) { event.preventDefault(); event.stopImmediatePropagation(); }
      },true);
      mobile.addEventListener('change',sync);
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cqz-paris-duo-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const marker = document.getElementById('cqz-paris-duo');
      if (!marker) return;
      const mobile = window.matchMedia('(max-width: 767px)');
      const description = document.querySelector('.cqz-pd-description');
      const outer = description?.closest('details');
      const heading = outer?.querySelector(':scope > summary');
      const outerWasOpen = outer?.open;
      const originalAttributes = heading ? Array.from(heading.attributes).map(attribute => [attribute.name, attribute.value]) : [];
      const toggle = description?.querySelector('.cqz-pd-toggle');
      const template = document.getElementById('cqz-paris-duo-payments');
      const purchase = document.querySelector('.cqz-pd-purchase');
      const price = document.querySelector('.hdt-product-info__list > .hdt-product__price');
      const buy = document.querySelector('.hdt-product-info__list > .hdt-product__buy-button');
      const backups = new Map();
      const replace = (node, content) => {
        if (!node) return;
        if (!backups.has(node)) backups.set(node, Array.from(node.childNodes));
        node.replaceChildren(content);
      };
      const cart = () => {
        if (!mobile.matches) return;
        const drawer = document.getElementById('CartDrawer');
        if (!drawer) return;
        const title = drawer.querySelector('.hdt-minicart-recommendations__title');
        if (title && title.textContent.trim() !== marker.dataset.recommendations) replace(title, marker.dataset.recommendations);
        const target = drawer.querySelector('.hdt-mini-cart__imgtrust-svgs');
        if (target && !target.dataset.cqzPdPayments) {
          target.dataset.cqzPdPayments = 'true';
          replace(target, template.content.cloneNode(true));
        }
      };
      const observer = new MutationObserver(cart);
      const sync = () => {
        observer.disconnect();
        if (mobile.matches) {
          if (purchase && buy) buy.after(purchase);
          if (outer) outer.open = true;
          if (heading) {
            heading.removeAttribute('aria-expanded');
            heading.setAttribute('role', 'heading');
            heading.setAttribute('aria-level', '2');
            heading.setAttribute('tabindex', '-1');
          }
          if (toggle) description.dataset.enhanced = 'true';
          const delivery = document.querySelector('.hdt-pr-popup__delivery');
          if (delivery && delivery.textContent.trim() !== marker.dataset.delivery) replace(delivery, marker.dataset.delivery);
          cart();
          const drawer = document.getElementById('CartDrawer');
          if (drawer) observer.observe(drawer, { childList: true, subtree: true });
        } else {
          if (purchase && price) price.after(purchase);
          if (outer) outer.open = outerWasOpen;
          if (heading) {
            for (const attribute of Array.from(heading.attributes)) heading.removeAttribute(attribute.name);
            for (const [name, value] of originalAttributes) heading.setAttribute(name, value);
          }
          if (description) delete description.dataset.enhanced;
          for (const [node, children] of backups) {
            if (node.isConnected) {
              node.replaceChildren(...children);
              delete node.dataset.cqzPdPayments;
            }
          }
          backups.clear();
        }
      };
      toggle?.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        toggle.querySelector('span').textContent = open ? '−' : '+';
      });
      heading?.addEventListener('click', event => {
        if (mobile.matches) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      mobile.addEventListener('change', sync);
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cqz-single-perfume-mobile"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const marker = document.getElementById('cqz-single-perfume-mobile');
      if (!marker) return;
      const mobile = window.matchMedia('(max-width: 767px)');
      const description = document.querySelector('.cqz-sp-description');
      const outer = description?.closest('details');
      const heading = outer?.querySelector(':scope > summary');
      const outerWasOpen = outer?.open;
      const originalAttributes = heading ? Array.from(heading.attributes).map(attribute => [attribute.name, attribute.value]) : [];
      const toggle = description?.querySelector('.cqz-sp-toggle');
      const template = document.getElementById('cqz-single-perfume-payments');
      const backups = new Map();
      const replace = (node, content) => {
        if (!node) return;
        if (!backups.has(node)) backups.set(node, Array.from(node.childNodes));
        node.replaceChildren(content);
      };
      const enhanceCart = () => {
        if (!mobile.matches) return;
        const drawer = document.getElementById('CartDrawer');
        if (!drawer) return;
        const title = drawer.querySelector('.hdt-minicart-recommendations__title');
        if (title && title.textContent.trim() !== marker.dataset.recommendations) replace(title, marker.dataset.recommendations);
        const target = drawer.querySelector('.hdt-mini-cart__imgtrust-svgs');
        if (target && !target.dataset.cqzSinglePerfumePayments) {
          target.dataset.cqzSinglePerfumePayments = 'true';
          replace(target, template.content.cloneNode(true));
        }
      };
      const observer = new MutationObserver(enhanceCart);
      const sync = () => {
        observer.disconnect();
        if (mobile.matches) {
          if (outer) outer.open = true;
          if (heading) {
            heading.removeAttribute('aria-expanded');
            heading.setAttribute('role', 'heading');
            heading.setAttribute('aria-level', '2');
            heading.setAttribute('tabindex', '-1');
          }
          if (toggle) description.dataset.enhanced = 'true';
          enhanceCart();
          const drawer = document.getElementById('CartDrawer');
          if (drawer) observer.observe(drawer, { childList: true, subtree: true });
        } else {
          if (outer) outer.open = outerWasOpen;
          if (heading) {
            for (const attribute of Array.from(heading.attributes)) heading.removeAttribute(attribute.name);
            for (const [name, value] of originalAttributes) heading.setAttribute(name, value);
          }
          if (description) delete description.dataset.enhanced;
          for (const [node, children] of backups) {
            if (node.isConnected) {
              node.replaceChildren(...children);
              delete node.dataset.cqzSinglePerfumePayments;
            }
          }
          backups.clear();
        }
      };
      toggle?.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        toggle.querySelector('span').textContent = open ? '−' : '+';
      });
      heading?.addEventListener('click', event => {
        if (mobile.matches) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      mobile.addEventListener('change', sync);
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
